import React from 'react';
import { Grid, Typography, TextField } from '@mui/material';
import CustomDialog from '../../../components/CustomDialog';
import { FaSave } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';
import SaveLoading from '../../../components/SaveLoading';

const EditLimitDialog = (props) => {
    const {
        open,
        setOpen,
        handleSave,
        editedData,
        setEditedData,
        saveLoading,
        editMode = 'limit',
    } = props;
    const isMinimumLimit = editMode === 'minimum';

    const handleOnTextChange = (value, name) => {
        setEditedData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleClose = () => setOpen(false);

  return (
    <CustomDialog open={open} >
         {saveLoading &&
                <SaveLoading loading={saveLoading} />
            }
        <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Typography className='text-customForeColor dark:text-customWhite'>
                        {isMinimumLimit ? 'Minimum Amount' : 'Amount'}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <TextField
                        size="small"
                        type="number"
                        label={isMinimumLimit ? 'Minimum Amount' : 'Amount'}
                        value={isMinimumLimit ? editedData?.minBetAmount ?? '' : editedData?.amount ?? ''}
                        onChange={(e) => handleOnTextChange(
                            e.target.value,
                            isMinimumLimit ? 'minBetAmount' : 'amount'
                        )}
                        inputProps={{ min: 0 }}
                        sx={{
                            '& .MuiInputLabel-root': {
                                color: '#6B6B6B',
                            },
                            '& .MuiInputBase-input': {
                                color: '#2E2E2E',
                            },
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: '#FFFFFF',
                                '& fieldset': {
                                    borderColor: '#D1DAE4',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#A6AECE',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#6574FF',
                                },
                            },
                            '.dark & .MuiInputLabel-root': {
                                color: '#A6AECE',
                            },
                            '.dark & .MuiInputLabel-root.Mui-focused': {
                                color: '#F1F9F1',
                            },
                            '.dark & .MuiInputBase-input': {
                                color: '#F1F9F1',
                            },
                            '.dark & .MuiOutlinedInput-root': {
                                backgroundColor: '#1B263B',
                            },
                            '.dark & .MuiOutlinedInput-root fieldset': {
                                borderColor: '#4B4E6D',
                            },
                            '.dark & .MuiOutlinedInput-root:hover fieldset': {
                                borderColor: '#A8DADC',
                            },
                            '.dark & .MuiOutlinedInput-root.Mui-focused fieldset': {
                                borderColor: '#A8DADC',
                            },
                        }}
                    />
                </Grid>
        </Grid>
        {!isMinimumLimit && <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Typography className='text-customForeColor dark:text-customWhite'>Risk Bet Amount</Typography>
                </Grid>
                <Grid item xs={8}>
                    <TextField
                        size="small"
                        label="Risk Bet Amount"
                        value={editedData?.riskBetLimit}
                        onChange={(e) => handleOnTextChange(e.target.value, 'riskBetLimit')}
                        sx={{
                            '& .MuiInputLabel-root': {
                                color: '#6B6B6B',
                            },
                            '& .MuiInputBase-input': {
                                color: '#2E2E2E',
                            },
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: '#FFFFFF',
                                '& fieldset': {
                                    borderColor: '#D1DAE4',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#A6AECE',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#6574FF',
                                },
                            },
                            '.dark & .MuiInputLabel-root': {
                                color: '#A6AECE',
                            },
                            '.dark & .MuiInputLabel-root.Mui-focused': {
                                color: '#F1F9F1',
                            },
                            '.dark & .MuiInputBase-input': {
                                color: '#F1F9F1',
                            },
                            '.dark & .MuiOutlinedInput-root': {
                                backgroundColor: '#1B263B',
                            },
                            '.dark & .MuiOutlinedInput-root fieldset': {
                                borderColor: '#4B4E6D',
                            },
                            '.dark & .MuiOutlinedInput-root:hover fieldset': {
                                borderColor: '#A8DADC',
                            },
                            '.dark & .MuiOutlinedInput-root.Mui-focused fieldset': {
                                borderColor: '#A8DADC',
                            },
                        }}
                    />
                </Grid>
        </Grid>}
        <div className='flex justify-center items-center gap-4 mt-3 text-[0.875rem]'>
                <div className='flex items-center gap-2'>
                    <button
                        type="button"
                        disabled={saveLoading || (isMinimumLimit && editedData?.minBetAmount === '')}
                        onClick={() => handleSave(editedData)}
                        className='flex items-center px-3 py-1 border rounded bg-customAccentBlue text-customBackColor disabled:cursor-not-allowed disabled:opacity-50 dark:bg-customAccent dark:border-customAccent'
                    >
                        <FaSave className='mr-1' />Save
                    </button>
                </div>
                <div className='flex items-center gap-2'>
                    <button
                        type="button"
                        disabled={saveLoading}
                        className='flex items-center px-3 py-1 border rounded bg-customTitleColor text-customForeColor dark:bg-custom_dark_secondary dark:border-custom_dark_secondary dark:text-customWhite'
                        onClick={() => handleClose()}
                    ><ImCross className='mr-1' />Cancel
                    </button>
                </div>
            </div>
    </CustomDialog>
  )
}

export default EditLimitDialog;
